import React from "react";
import "./TokenFailPage.css";

import { Container } from "reactstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation, faRotateRight } from "@fortawesome/free-solid-svg-icons";

// Map the `state.origin` tag passed by the redirecting component to a
// short human-readable label that helps support correlate logs.
const ORIGIN_LABELS = {
  "load-form": "Loading the employee form",
  "auth-types": "Verifying the form link",
};

const TokenFailPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const message = location.state?.message;
  const failedToken = location.state?.token;
  const originLabel = ORIGIN_LABELS[location.state?.origin];

  const onTryAgain = () => {
    if (failedToken) {
      navigate(`/${failedToken}`, { replace: true });
    } else {
      // Hard reload as a last-resort recovery path.
      window.location.reload();
    }
  };

  return (
    <Container className="emp-tokenfail">
      <div className="emp-tokenfail-card" role="alert" aria-live="assertive">
        <div className="emp-tokenfail-card__hero">
          <div className="emp-tokenfail-card__icon-wrapper">
            <FontAwesomeIcon icon={faTriangleExclamation} className="emp-tokenfail-card__icon" />
          </div>
          <h1 className="emp-tokenfail-card__title">We could not open this form</h1>
        </div>

        <div className="emp-tokenfail-card__body">
          <p className="emp-tokenfail-card__lead">
            The link you used is no longer working.
          </p>

          {message ? (
            <p className="emp-tokenfail-card__reason">
              <strong>Reason</strong>
              {message}
            </p>
          ) : null}

          <p className="emp-tokenfail-card__hint">
            If you reached this page after clicking a link in an e-mail or SMS, the link
            may have expired. Please contact Hafnia and share the details below so we
            can help you continue.
          </p>

          {(failedToken || originLabel) ? (
            <div className="emp-tokenfail-card__details" aria-label="Diagnostic details">
              {originLabel ? <span>Step: {originLabel}</span> : null}
              {failedToken ? <span>Reference: {failedToken}</span> : null}
            </div>
          ) : null}
        </div>

        <div className="emp-tokenfail-card__actions">
          <button type="button" className="emp-tokenfail-card__btn" onClick={onTryAgain}>
            <FontAwesomeIcon icon={faRotateRight} />
            Try again
          </button>
        </div>
      </div>
    </Container>
  );
};

export default TokenFailPage;
